import { Formik, FormikProps } from "formik";
import SimpleModal from "lib/components/common/simple-modal";
import { DEFAULT_FEATURE_VALUES } from "lib/constants/default-values";
import { UPSERT_FEATURE_VALIDATION_SCHEME } from "lib/constants/validation-constants";
import { useRef } from "react";
import { Button, Form } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import { MdCancel } from "react-icons/md";

interface Props {
  featureInfo: FeatureDetails | null;
  open: boolean;
  onClose: (data: FeatureDetails | null) => void;
  features: string[];
}

const UpsertFeature = ({ featureInfo, open, onClose, features }: Props) => {
  const formikRef = useRef<FormikProps<any>>(null);

  const getFooter = () => {
    return (
      <Button
        type="button"
        className="w-auto"
        onClick={() => formikRef.current?.handleSubmit()}
      >
        Save
      </Button>
    );
  };

  const getDefaultValue = () => {
    return {
      ...DEFAULT_FEATURE_VALUES,
      id: +new Date(),
    };
  };

  return (
    <SimpleModal
      size="lg"
      open={open}
      close={() => onClose(null)}
      title="Feature Details"
      footer={getFooter()}
    >
      <Formik
        innerRef={formikRef}
        initialValues={featureInfo || getDefaultValue()}
        validationSchema={UPSERT_FEATURE_VALIDATION_SCHEME}
        onSubmit={(values: FeatureDetails) => {
          console.log("values", values);
          onClose(values);
        }}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <Form onSubmit={handleSubmit}>
            <Form.Group className="form-group">
              <Form.Label>
                Feature&nbsp;<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                as="select"
                name="name"
                className={`form-control ${
                  touched.name && errors.name ? "is-invalid" : ""
                }`}
                onBlur={handleBlur}
                value={values.name}
                onChange={handleChange}
              >
                <option value="" disabled>
                  Select Feature
                </option>
                {features.map((feature: string, index: number) => (
                  <option value={feature} key={index}>
                    {feature}
                  </option>
                ))}
              </Form.Control>
              {touched.name && errors.name && (
                <div className="invalid-feedback">{errors.name as string}</div>
              )}
            </Form.Group>
            <Form.Group className="form-group">
              <Form.Label>
                Label&nbsp;<span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                className={`form-control ${
                  touched.label && errors.label ? "is-invalid" : ""
                }`}
                onBlur={handleBlur}
                type="text"
                name="label"
                value={values.label}
                onChange={handleChange}
              />
              {touched.label && errors.label && (
                <div className="invalid-feedback">{errors.label as string}</div>
              )}
            </Form.Group>
            <Form.Group className="form-group">
              <div className="d-flex align-items-center gap-2">
                <MdCancel
                  className="text-danger flex-shrink-0 me-2"
                  size={20}
                />
                <Form.Check
                  type="switch"
                  name="isAvailable"
                  checked={values.isAvailable}
                  onChange={handleChange}
                />
                <div>
                  <FaCheckCircle className="text-success flex-shrink-0 me-2" />
                  (Available)
                </div>
              </div>

              <Form.Label></Form.Label>
            </Form.Group>
          </Form>
        )}
      </Formik>
    </SimpleModal>
  );
};

export default UpsertFeature;
